<template>
  <header class="header">
    <a :href="chounEnvDomain" class="header__logo">
      <img src="/static/img/choundiary/logo.png" alt="">
    </a>
  </header>
</template>

<script>
import getChounEnvDomain from '@/utils/getChounEnvDomain'

export default {
  name: 'HeaderChoun',
  data() {
    return {
      chounEnvDomain: getChounEnvDomain(),
    }
  },
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  height: 64px;
  width: 100%;
  z-index: 90001;
  top: 0;
  left: 0;
  background: #FFE546;
  &__logo {
    display: table;
    margin: 20px auto 0;
    img {
      max-width: 152px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/HeaderChoun.vue